module.exports = __webpack_public_path__ + "static/media/1.aa535c26.jpg";